import React from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ThemeProvider } from './src/context/themecontext';
import { ApiProvider } from './src/context/apicontext';
import { SessionProvider } from './src/context/sessioncontext';

export const wrapPageElement = ({ element }) => {
	// Retrieve and apply theme preference to body before rendering layout (i.e. avoid background flash)
	//	This is not responsive to live theme changes, but will update on next page load
	const themePreference = localStorage.getItem('themePreference');
	const theme = themePreference ? JSON.parse(themePreference) : 'light';
	document.body.classList.remove('darkBody');
	if (theme === 'dark') document.body.classList.add(`${theme}Body`);

	return (
		<React.Fragment>
			{element}
			<ToastContainer
				position='bottom-center'
				autoClose={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
			/>
		</React.Fragment>
	);
};

export const wrapRootElement = ({ element }) => {
	return (
		<ThemeProvider>
			<ApiProvider>
				<SessionProvider>
					{element}
				</SessionProvider>
			</ApiProvider>
		</ThemeProvider>
	);
};
